import React from "react";

export const DraggableListItemContext = React.createContext({
  index: 0,
  isDragging: false,
  isDraggedOverAbove: false,
  isDraggedOverBelow: false,
  disabled: false
});
